(function () {
  if (window.__lpvpATCInitialized) return;
  window.__lpvpATCInitialized = true;

  async function refreshBubbleCount() {
    try {
      const res = await fetch('/cart.js');
      if (res.status === 429) return;
      const data = await res.json();
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = data.item_count;
      });
    } catch (err) {
      console.error('[LPVP] Cart count refresh error:', err);
    }
  }

  function getVariantId(card, key) {
    if (!card) return '';
    return card.getAttribute(key) || '';
  }

  function getVariantIdsFromCard(card) {
    if (!card) return [];
    const ids = [];
    const id1 = getVariantId(card, 'data-variant-id-1');
    const id2 = getVariantId(card, 'data-variant-id-2');
    if (id1) ids.push(id1);
    if (id2) ids.push(id2);
    return ids;
  }

  function getVariantIdsFromButton(btn) {
    const ids = [];
    const id1 = getVariantId(btn, 'data-variant-id-1');
    const id2 = getVariantId(btn, 'data-variant-id-2');
    if (id1) ids.push(id1);
    if (id2) ids.push(id2);
    return ids;
  }

  function cardHasVariantIds(card) {
    return getVariantIdsFromCard(card).length > 0;
  }

  function getCheckedRadio(section) {
    const radios = section.querySelectorAll('.lpvp-card-radio');
    return Array.from(radios).find(function (radio) {
      return radio.checked;
    });
  }

  function ensureDefaultSelection(section) {
    const radios = section.querySelectorAll('.lpvp-card-radio');
    if (!radios.length) return;

    if (getCheckedRadio(section)) return;

    const withCheckedAttr = section.querySelector('.lpvp-card-radio[checked]');
    const defaultRadio = withCheckedAttr || radios[1] || radios[0];
    defaultRadio.checked = true;
  }

  function getActiveCard(section) {
    const checkedRadio = getCheckedRadio(section);
    if (checkedRadio) {
      const card = checkedRadio.closest('.lpvp-card');
      if (card && cardHasVariantIds(card)) return card;
    }

    const cardFromHas = section.querySelector('.lpvp-card:has(.lpvp-card-radio:checked)');
    if (cardFromHas && cardHasVariantIds(cardFromHas)) return cardFromHas;

    const cards = section.querySelectorAll('.lpvp-card');
    for (let i = 0; i < cards.length; i++) {
      if (cardHasVariantIds(cards[i])) return cards[i];
    }

    return null;
  }

  function getLpvpSection(btn) {
    const section = btn.closest('.landing-product-variant-picker');
    if (!section) return null;

    if (section.offsetParent !== null) return section;

    const sections = document.querySelectorAll('.landing-product-variant-picker');
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].offsetParent !== null) return sections[i];
    }

    return section;
  }

  function getSkinConcernFromPath() {
    const pageLink = window.location.pathname;
    if (
      pageLink.includes('landing-neuro-lp-google') ||
      pageLink.includes('neuro-angebot-2') ||
      pageLink.includes('neuro-lp-google')
    ) {
      return 'neurodermitis';
    }
    if (pageLink.includes('rosacea-lp-google')) {
      return 'roascea';
    }
    if (pageLink.includes('hormonelleakne-lp-google')) {
      return 'akne';
    }
    return null;
  }

  async function addVariantsToCart(variantIds) {
    const ids = variantIds.filter(Boolean);
    if (!ids.length) throw new Error('No variant IDs');

    const skinConcern = getSkinConcernFromPath();
    const lineProperties = skinConcern ? { _skinConcern: skinConcern } : null;

    const body =
      ids.length === 1
        ? JSON.stringify(
            lineProperties
              ? { id: ids[0], quantity: 1, properties: lineProperties }
              : { id: ids[0], quantity: 1 }
          )
        : JSON.stringify({
            items: ids.map(function (id) {
              return lineProperties
                ? { id: id, quantity: 1, properties: lineProperties }
                : { id: id, quantity: 1 };
            }),
          });

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
    });

    if (!res.ok) throw new Error('Add to cart failed');
    if (ids.length > 1) {
      console.log("The discount code is applied");
      let pageLink = window.location.pathname;
      if (
        pageLink.includes("landing-neuro-lp-google") ||
        pageLink.includes("neuro-angebot-2") ||
        pageLink.includes("neuro-lp-google")
      ) {
        await fetch('/discount/Bundle-Discount-Neuro');
      } else if (pageLink === "/pages/rosacea-lp-google" || pageLink === '/pages/rosacea-lp') {
        await fetch('/discount/Bundle-Discount-Roascea');
      } else if (pageLink === "/pages/hormonelleakne-lp-google" || pageLink === "/pages/aknelp-fb") {
        await fetch('/discount/Bundle-Discount-Akne');
      }
    }

    return res.json();
  }

  async function handleAddToCart(btn, variantIds) {
    if (btn.disabled) return;

    const originalBackground = btn.style.background;
    btn.disabled = true;
    btn.classList.add('lpvp-ATC-button--loading');

    try {
      await addVariantsToCart(variantIds);
      btn.classList.add('lpvp-ATC-button--success');

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('theme:cart:update'));
      await refreshBubbleCount();

      const cartDrawerBtn = document.querySelector('.cart-drawer-button');
      if (cartDrawerBtn) cartDrawerBtn.click();

      setTimeout(function () {
        btn.classList.remove('lpvp-ATC-button--success');
        btn.classList.remove('lpvp-ATC-button--loading');
        btn.disabled = false;
      }, 2000);
    } catch (err) {
      console.error('[LPVP] Add to cart error:', err);
      btn.classList.remove('lpvp-ATC-button--loading');
      btn.style.background = '#e44';
      setTimeout(function () {
        btn.style.background = originalBackground;
        btn.disabled = false;
      }, 2000);
    }
  }

  function initV1() {
    document.querySelectorAll('.landing-product-variant-picker').forEach(function (section) {
      ensureDefaultSelection(section);

      const btn = section.querySelector('#lpvp-ATC-button');
      if (!btn || btn.dataset.lpvpBound === 'true') return;
      btn.dataset.lpvpBound = 'true';

      const buttonUrl = (section.dataset.buttonUrl || '').trim();

      btn.addEventListener('click', function () {
        if (buttonUrl) {
          window.location.href = buttonUrl;
          return;
        }

        const activeSection = getLpvpSection(btn) || section;
        ensureDefaultSelection(activeSection);

        const card = getActiveCard(activeSection);
        const variantIds = getVariantIdsFromCard(card);

        if (!variantIds.length) {
          console.warn('[LPVP] No variant selected', {
            sectionId: activeSection.dataset.lpvpSectionId,
            cards: activeSection.querySelectorAll('.lpvp-card').length,
            checked: !!getCheckedRadio(activeSection),
          });
          return;
        }

        handleAddToCart(btn, variantIds);
      });
    });
  }

  function initV2() {
    document.querySelectorAll('.landing-product-variant-picker-v2 .lpvp2-ATC-button').forEach(function (btn) {
      if (btn.dataset.lpvpBound === 'true') return;
      btn.dataset.lpvpBound = 'true';

      const section = btn.closest('.landing-product-variant-picker-v2');
      const buttonUrl = section ? (section.dataset.buttonUrl || '').trim() : '';

      btn.addEventListener('click', function () {
        if (buttonUrl) {
          window.location.href = buttonUrl;
          return;
        }

        const variantIds = getVariantIdsFromButton(btn);
        if (!variantIds.length) {
          console.warn('[LPVP] No variant IDs on button');
          return;
        }

        handleAddToCart(btn, variantIds);
      });
    });
  }

  function init() {
    initV1();
    initV2();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
